// extracted by mini-css-extract-plugin
export var typingIndicator = "_sn-0";